import styled from 'styled-components';
import { Select, MenuItem } from '@mui/material';

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CompactSelect = styled(Select)`
  & .MuiSelect-select {
    padding: 3px 12px;
    font-size: 14px;
    height: auto;
  }
`;

export const CompactMenuItem = styled(MenuItem)`
  font-size: 14px;
  padding: 6px 12px;
  min-height: 32px;
`;